<template>
  <div></div>
</template>
<script>
export default {
  name: "face1",
  mounted() {
    //   if (this.cancel) {
    //       this.showAlert()
    //   } else {
    //        this.showConfirm()
    //   }
    // localStorage.setItem("faceidentify", "0");
    this.showAuth();
  },
  methods: {
    showAuth() {
      // this.$dialog
      //   .confirm({
      //     title: "身份验证",
      //     message: "请打开前置摄像头进行实名验证。",
      //   })
      //   .then(() => {
      //   window.location.href=`https://brain.baidu.com/face/print/?token=Vdpi69tQkT3hobYcWrBSXLF0&successUrl=https://www.sina.com.cn&failedUrl=${failedUrl}`
      var faceauthlocalUrl = window.location.href;
      localStorage.setItem("faceauthlocalUrl", faceauthlocalUrl);
      // this.$router.push("/faceidentify")
      this.$api.face
        .getvirefytoken({ data: {} })
        .then((res) => {
          var virefytoken = encodeURIComponent(`${res.data}`);
          var successUrl = encodeURIComponent(
            `${window.location.protocol}//${window.location.host}/faceauthsuccess?token=${virefytoken}&type=0`
          );
          var failedUrl = encodeURIComponent(
            `${window.location.protocol}//${window.location.host}/faceauthfail?type=0`
          );
          window.location.href = `https://brain.baidu.com/face/print/?token=${virefytoken}&successUrl=${successUrl}&failedUrl=${failedUrl}`;
        })
        .catch((error) => {
          this.$toast("请重试");
        });
     
    },
  },
};
</script>
<style></style>